import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contadorpage',
  templateUrl: './contadorpage.component.html',
  styleUrls: ['./contadorpage.component.scss']
})
export class ContadorpageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
